import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { tabListData , tabPannelName} from '../../Configuration/ConfigurationMenu';
import ConfigurationUser from './User/User';
import ConfigurationRole from './Role';
import { useDispatch, useSelector } from 'react-redux';
import ConfigurationLookup from './Lookup';
import Internationalise from './Internationalise';
import { handleValidateCodevalue } from '../../Utility/constant';
import { handleCreateEditConfiguration } from '../../Store/Global/action';
import CreateEditOrg from './Organization/CreateEditOrg';
import CustomizationPage from './Customization';
const ConfigurationPage = ({}) => {
    const [selectedTab, setSelectedTab] = React.useState('role');
   const currentUser = useSelector(state => state?.owner?.currentuser);
    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };
    const dispatch = useDispatch()
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    useEffect(()=>{
    return ()=>{
        dispatch( handleCreateEditConfiguration(false))
    }
    },[])
    const isCreateEdit = useSelector(state => state?.global?.isCreateEdit);
    return (
        <React.Fragment>
            <Box sx={{ width: '99%', marginLeft: "8px", typography: 'body1', backgroundColor: "transparent"}}>
                <TabContext value={selectedTab}>
                    {!isCreateEdit && <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: 'white',borderRadius: "10px"}}>
                        <TabList onChange={handleChange} variant ="fullWidth" aria-label="configuration Menu" allowScrollButtonsMobile>
                            {
                                tabListData.map((item, index) => {
                                    return <Tab key={item.value || index} label={handleValidateCodevalue(internationalise,item?.label)} value= {item?.value} />
                                })
                            }
                        </TabList>
                    </Box>}
                    {/* <TabPanel  value={tabPannelName?.application}>
                       <ConfigurationApplication />
                    </TabPanel> */}
                    {/* <TabPanel value={tabPannelName?.function} className='tabpannel'>
                       <ConfigurationFunction />
                    </TabPanel> */}
                    {/* <TabPanel value={tabPannelName?.menu}>
                       <ConfigurationMenu />
                    </TabPanel> */}
                    <TabPanel value={tabPannelName?.role}>
                         <ConfigurationRole />
                    </TabPanel>
                    <TabPanel value={tabPannelName?.internationalise}>
                         <Internationalise />
                    </TabPanel>
                    <TabPanel value={tabPannelName?.user}>
                        <ConfigurationUser />
                    </TabPanel>
                    <TabPanel value={tabPannelName?.lookup}>
                        {/* <DropDownCustomization /> */}
                        <ConfigurationLookup />
                    </TabPanel>
                    <TabPanel value={tabPannelName?.customization}>
                      <CustomizationPage/>
                    </TabPanel>
                    <TabPanel value={tabPannelName?.about}>
                         <CreateEditOrg
                    isEdituser = {true} 
                    currentcompanyid={currentUser?.client?.id}
                    iscreateuser = {false}
                />  
                    </TabPanel>
                </TabContext>
            </Box>
        </React.Fragment>
    )
}

export default ConfigurationPage;